import { BASE_GROUP_MANAGEMENT_PATH, DASHBOARD_PATH } from "common/constants";
import { WorkspaceType } from "@shared/types";

export const workspaceToDefaultPath = {
  [WorkspaceType.ADMIN]: BASE_GROUP_MANAGEMENT_PATH,
  [WorkspaceType.USER]: DASHBOARD_PATH,
  [WorkspaceType.DEMO]: DASHBOARD_PATH,
};

export const NO_SUBSCRIPTION_WARNING_MESSAGE =
  "The user trading interface is only accessible for users with an active subscription";

export const HEADER_HEIGHT = 80;
export const MOBILE_HEADER_HEIGHT = 56;

export const BOTTOM_SPACER_HEIGHT = 90;
